import vue from 'vue'
import Router from 'vue-router'
vue.use(Router)
import iView from 'iview'
vue.use(iView)
import routes from "./routes"

const router = new Router({
  routes: routes
});

router.beforeEach((to, from, next) => {
  let { isShowFooter = false, isShowLeftSider = false } = to.meta;
  // 如果是本地开发环境，就用固定的 token值，不然接口是不成功的，不过30天后也会过期
  if (process.env.NODE_ENV === 'development') {
  } else {
  }
  next();
});

iView.LoadingBar.config({
  color: '#5cb85c',
  failedColor: '#f0ad4e',
  height: 3
});

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  next();
});

router.afterEach(route => {
  //将滚动条恢复到最顶端
  window.scrollTo(0, 0);
  iView.LoadingBar.finish();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js